export default __webpack_public_path__ + "static/media/arrow-left.inline.2aaf99f4.svg";